import React, { useState, useEffect } from 'react'
import L from 'leaflet';
import { MapContainer, TileLayer, GeoJSON } from 'react-leaflet'
import country from '../shapefiles/country.json'
import GeotiffLayer from './GeoTiffLayer'
// import DatePicker from 'sassy-datepicker';
// import DatePicker from "react-datepicker";
import TextField from '@material-ui/core/TextField';
// import "react-datepicker/dist/react-datepicker.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import graph1 from '../img/graph1.JPG'
import graph2 from '../img/graph2.JPG'
import DownloadFile from './DownloadFile';

import '../css/date.css'

const IntractiveMap = () => {
    let DateObj = new Date();

    let currentDate = `${DateObj.getFullYear()}-${(DateObj.getMonth() < 10 ? '0' : '') + (DateObj.getMonth() + 1)}-${(DateObj.getDate() < 10 ? '0' : '') + (DateObj.getDate())}`
    let cDate = `${DateObj.getFullYear()}${(DateObj.getMonth() < 10 ? '0' : '') + (DateObj.getMonth() + 1)}${(DateObj.getDate() < 10 ? '0' : '') + (DateObj.getDate())}`




    // const tiffUrl1 = require(`../img/tif2022-05-10.tif`);






    const position = [14.300, -15.467];
    const getInitialState = () => {
        const value = "Country Level";
        return value;
    };
    const getInitialState1 = () => {
        const value = "severity";
        return value;
    };
    const getInitialState2 = () => {
        const value = "CDI";
        return value;
    };
    const getInitialState3 = () => {
        const value = "1 Year";
        return value;
    };
    const getInitialState4 = () => {
        const value = "CDI";
        return value;
    };


    const [value, setValue] = useState(getInitialState);
    const [value1, setValue1] = useState(getInitialState1);
    const [value2, setValue2] = useState(getInitialState2);
    const [value3, setValue3] = useState(getInitialState3);
    const [value4, setValue4] = useState(getInitialState4)
    const [flag, setFlag] = useState(true)
    const [date, setDate] = useState(cDate)

    const [map, setMap] = useState(null);


    const handleChange = (e) => {
        setValue(e.target.value);
        if (e.target.value === 'Country Level') {
            setFlag(true);
        }
        else {
            setFlag(false);
        }

    };
    const handleChange1 = (e) => {
        setValue1(e.target.value);
        console.log(value1);
    };

    const handleChange2 = (e) => {
        setValue2(e.target.value);
    };
    const handleChange3 = (e) => {
        setValue3(e.target.value);
    };
    const handleChange4 = (e) => {
        setValue4(e.target.value);
    };
    // console.log(value1);
    // let date;
    // let filena;


    const onChange = () => {
        // let datee = document.getElementById("datePick").defaultValue = "2022-05-14";

        let datee = document.getElementById("datePick").value;
        datee = datee.replace(/-| /g, '');
        console.log(datee);
        // console.log(datee.getMonth());
        setDate(datee);
        // filena=`${value1}_${date}`;
        // console.log(filena);
    }
    let tiffUrl;
    if (value1 === 'spi3') {
        try {
            tiffUrl = require(`../img/Page_1/nowcast/spi3/spi3_${date}_01_00.tif`);
        }
        catch (err) {
            alert(err);
        }
    }
    if (value1 === 'severity') {
        try {
            tiffUrl = require(`../img/severity/severity_${date}_0.tif`);
        }
        catch (err) {
            try {
                tiffUrl = require(`../img/severity/severity_${date}_01_00.tif`)
            }
            catch (err) {
                alert(err);
            }
        }
    }
    if (value1 === 'Root-zone') {
        try {
            tiffUrl = require(`../img/soil_moist/soil_moist_${date}_02_00.tif`);
        }
        catch (err) {
            alert(err);
        }
    }


    const color = (val) => {
        // console.log(val)
        if (value1 === 'spi3') {
            if (val[0] === NaN) {
                return 'transparent'
            }
            else if (val[0] > -0.50) {
                return '#BDDA57'
            }
            else if (val[0] > -1.0 && val[0] <= -0.50) {
                return '#FFFF00'
            }
            else if (val[0] > -1.5 && val[0] <= -1.0) {
                return '#FCD37F'
            }
            else if (val[0] > -2.0 && val[0] <= -1.5) {
                return '#FFAA00'
            }
            else if (val[0] > -3.0 && val[0] <= -2.0) {
                return '#E60000'
            }
            else if (val[0] <= -3.0) {
                return '#730000'
            }
            else {
                return
            }
        }
        if (value1 === 'severity') {
            if (val[0] === NaN) {
                return 'transparent'
            }
            else if (val[0] >= 90) {
                return '#8B0000'
            }
            else if (val[0] >= 80 && val[0] <= 90) {
                return '#DC143C'
            }
            else if (val[0] >= 70 && val[0] <= 80) {
                return '#FF0000'
            }
            else if (val[0] >= 60 && val[0] <= 70) {
                return '#FF6347'
            }
            else if (val[0] >= 50 && val[0] <= 60) {
                return '#FF8C00'
            }
            else if (val[0] >= 40 && val[0] <= 50) {
                return '#FFA500'
            }
            else if (val[0] >= 30 && val[0] <= 40) {
                return '#FFC000'
            }
            else if (val[0] >= 20 && val[0] <= 30) {
                return '#FFD700'
            }
            else if (val[0] >= 10 && val[0] <= 20) {
                return '#FFEA00'
            }
            else if (val[0] <= 10) {
                return '#fdfd96'
            }
        }
        if (value1 === 'Root-zone') {
            if (val[0] === NaN) {
                return 'transparent'
            }
            else if (val[0] >= 50) {
                return ' #00008B'
            }
            else if (val[0] >= 40 && val[0] <= 50) {
                return '#4682B4'
            }
            else if (val[0] >= 30 && val[0] <= 40) {
                return '#228B22'
            }
            else if (val[0] >= 20 && val[0] <= 30) {
                return ' #9ACD32'
            }
            else if (val[0] >= 10 && val[0] <= 20) {
                return '#FFD700'
            }
            else if (val[0] <= 10) {
                return '#FFA500'
            }
        }


    }
    const options = {
        pixelValuesToColorFn: (values) =>
            color(values),
        resolution: 64,
        opacity: 1
    };





    // if(!tiffUrl){
    //     alert('File Not Found');
    // }
    // let tiffUrl;
    // useEffect(() => {
    //     // let filena=`${value1}_${date}`
    //     // console.log(filena)
    //     try {
    //         if (require(`../img/${value1}_${date}.tif`)) {
    //             tiffUrl = require(`../img/${value1}_${date}.tif`);
    //             alert(tiffUrl);
    //         }
    //     }
    //     catch (err) {
    //         alert(err);
    //     }

    //     // const tiffUrl = require(`../img/${value1}_${date}.tif`);
    //     // console.log(tiffUrl)
    // }, [date, value1])


    // const onChange = (date) => {
    //     let Date = `${date.getFullYear()}-${(date.getMonth() < 10 ? '0' : '') + (date.getMonth() + 1)}-${(date.getDate() < 10 ? '0' : '') + (date.getDate())}`

    // };


    // useEffect(() => {
    //     if (!map) return;
    //     const datePick = document.getElementById('datePick');

    //     const customControler = L.Control.extend({
    //         options: {
    //             position: "topleft",
    //         },



    //         onAdd: function () {
    //             const info = L.DomUtil.create("div", "legend");
    //             info.innerHTML = datePick.innerHTML;

    //             // return info;


    //             info.onclick = function (date) {
    //                 console.log(date);
    //             };

    //             return info;
    //         },
    //     });

    //     map.addControl(new customControler());
    // }, [map]);


    return (
        <>


            <div className='grid place-items-center'>
                <div className="mt-4 flex text-4xl mx-[2.50rem] sm:px-6 ">
                    <div className='right'>
                        {/* Display map from map component  */}
                        <div className=' mt-4 h-[88vh] w-[60vw] p-4 ' >
                            <div className='bordder-4  bg-[#f8f9fa] flex justify-center items-center space-x-14'>
                                <div className='my-4 mx-2'>
                                    {/* <input  type='date' id="datePick"  onChange={onChange} value={date} className='w-34 h-10 text-lg uppercase' /> */}
                                    {/* <DatePicker onChange={onChange} /> */}
                                    <TextField type='date' defaultValue={currentDate} onChange={onChange} id="datePick" />
                                    {/* <DatePicker dateFormat="yyyymmdd" selected={currentDate} onChange={onChange} /> */}

                                </div>
                                <div className=' py-5 text-lg '>
                                    <p className='mx-5 font-bold uppercase'>AREA of Interest </p>
                                    <select className='border-solid border-2 text-xs border-orange-300 rounded-full hover:border-blue-300 w-56 h-10' value={value} onChange={handleChange}>
                                        {/* <option value="Mekong Region">Mekong Region</option>
                                    <option value="LMR Basin">LMR Basin</option> */}
                                        <option value="Country Level">Country Level</option>
                                        <option value="State level">State level</option>
                                        <option value="District level">District level</option>
                                        <option value="Administrative Level">Administrative Level</option>
                                        <option value="Clear Area">Clear Area</option>
                                    </select>
                                </div>
                                <div className=' py-5 text-lg '>
                                    <p className='mx-5 font-bold uppercase'>Select Indices/Variables <span> <FontAwesomeIcon title={`MS: Model Simulation`} className="h-4 w-4" icon={faInfoCircle} />  </span> </p>
                                    <select className='border-solid border-2 text-xs border-orange-300 rounded-full hover:border-blue-300 w-72 h-10' value={value1} onChange={handleChange1}>
                                        {/* <option value="CDI">MS: CDI- Combined Drought Index</option> */}
                                        <option value="severity">MS: Drought Severity</option>
                                        {/* <option value="MSDry">MS: Dry Spell Events</option>
                                        <option value="SMDI">MS: SMDI- Soil Moisture Decifit Index</option>
                                        <option value="SPI1">MS: SPI 1 month - Standardized Precipitation Index (1 month)</option> */}
                                        <option value="spi3">MS: SPI 3 month - Standardized Precipitation Index (3 month)</option>
                                        {/* <option value="SPI6">MS: SPI 6 month - Standardized Precipitation Index (6 month)</option>
                                        <option value="SRI1">MS: SRI 1 month - Standardized Runoff Index (1 month)</option>
                                        <option value="SRI3">MS: SRI 3 month - Standardized Runoff Index (3 month)</option>
                                        <option value="SRI6">MS: SRI 6 month - Standardized Runoff Index (6 month)</option>
                                        <option value="MSR">MS: Rainfall (mm)</option>
                                        <option value="soil_moists">MS: Surface Soil Moisture (mm)</option> */}
                                        <option value="Root-zone">MS: Root-zone Soil Moisture (%)</option>
                                        {/* <option value="ST">MS: Surface Temperature (°C)</option>
                                        <option value="MSST">MS: Soil Temperature (°C)</option>
                                        <option value="MAT">MS: Minimum Air Temperature (°C)</option>
                                        <option value="MSMAT">MS: Maximum Air Temperature (°C)</option>
                                        <option value="RH">MS: Relative Humidity (%)</option>
                                        <option value="MSE">MS: Evaporation (mm)</option>
                                        <option value="NSF">MS: Net Shortwave Flux (W/m2)</option>
                                        <option value="NLF">MS: Net Longwave Flux (W/m2)</option>
                                        <option value="PAR">MS: PAR - Photosynthetically Active Radiation (W/m2)</option>
                                        <option value="SR">MS: Surface Runoff (mm)</option>
                                        <option value="BF">MS: Base flow (mm/day)</option> */}


                                    </select>
                                </div>
                            </div>


                            <div className=''>


                                <MapContainer
                                    center={position}
                                    ref={setMap}
                                    maxZoom={7}
                                    minZoom={7}
                                    zoom={7}
                                    style={{ background: 'white', height: '73vh' }}
                                >
                                    <TileLayer
                                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                        url="https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}" />
                                    {flag ? <GeoJSON
                                        data={country}
                                        style={{ fillColor: 'transparent', color: 'black' }}
                                    /> : null}
                                    <TileLayer
                                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                        url="https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}" />
                                    <GeotiffLayer url={tiffUrl} options={options} />

                                    {/* {value1 === 'CDI' ? <>
                                        <TileLayer
                                            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                            url="https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}" />
                                        <GeotiffLayer url={tiffUrl} options={options} /> </> : <TileLayer
                                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                        url="https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}" />}

                                    {value1 === 'MSDrought' ? <>
                                        <TileLayer
                                            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                            url="https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}" />
                                        <GeotiffLayer url={tiffUrl} options={options} /> </> : <TileLayer
                                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                        url="https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}" />}
 */}

                                    {/* {flag1 ? <GeotiffLayer url={tiffUrl} options={options} /> : <TileLayer
                                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                        url="https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}" />}
                                    {flag1 === false ? <GeotiffLayer url={tiffUrl1} options={options} /> : <TileLayer
                                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                        url="https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}" />} */}

                                </MapContainer>

                            </div>

                            {/* <Map val={false} /> */}
                        </div>
                        <div className='flex '>
                            <div className='max-w-[26rem]'>
                                {value1 === 'spi3' ?
                                    <div className='py-6 mx-7'>
                                        <div className='my-5'>MS: SPI - 3 month</div>
                                        <div className='flex'>  <div className='border-2 w-8 h-6 mx-3 mt-2 bg-[#BDDA57] '></div> <div className='text-[14px]  '>Normal Drought  </div></div>
                                        <div className='flex'>  <div className='border-2 w-8 h-6 mx-3 mt-2 bg-[#FFFF00]'></div> <div className='text-[14px] '>Abnormally Dry  </div></div>
                                        <div className='flex'>  <div className='border-2 w-8 h-6 mx-3 mt-2 bg-[#FCD37F]'></div> <div className='text-[14px] '>Moderate Drought  </div></div>
                                        <div className='flex'>  <div className='border-2 w-8 h-6 mx-3 mt-2 bg-[#FFAA00]'></div> <div className='text-[14px] '>Severe Drought  </div></div>


                                        <div className='flex'>  <div className='border-2 w-8 h-6 mr-3 mx-3 mt-2 bg-[#E60000]'></div> <div className='text-[14px] '>Extreme Drought  </div></div>
                                        <div className='flex'>  <div className='border-2 w-8 h-6 mr-3 mx-3  mt-2 bg-[#730000]'></div> <div className='text-[14px] '>Exceptional Drought  </div></div>
                                        <div className='flex'>  <div className='border-2 w-8 h-6 mr-3 mx-3  mt-2 mb-3 '></div> <div className='text-[14px] '>No Data  </div></div>
                                    </div> :


                                    value1 === 'severity' ?
                                        <div className='py-6 mx-7'>
                                            <div className='my-5'>MS: Drought Severity</div>
                                            <div className='flex'>  <div className='border-2 w-8 h-6 mx-3 mt-2 bg-[#8B0000] '></div> <div className='text-[14px]  '>90 - 100  </div></div>
                                            <div className='flex'>  <div className='border-2 w-8 h-6 mx-3 mt-2 bg-[#DC143C]'></div> <div className='text-[14px] '>80 - 90  </div></div>
                                            <div className='flex'>  <div className='border-2 w-8 h-6 mx-3 mt-2 bg-[#FF0000]'></div> <div className='text-[14px] '>70 - 80  </div></div>
                                            <div className='flex'>  <div className='border-2 w-8 h-6 mx-3 mt-2 bg-[#FF6347]'></div> <div className='text-[14px] '>60 - 70  </div></div>


                                            <div className='flex'>  <div className='border-2 w-8 h-6 mr-3 mx-3 mt-2 bg-[#FF8C00]'></div> <div className='text-[14px] '>50 - 60  </div></div>
                                            <div className='flex'>  <div className='border-2 w-8 h-6 mr-3 mx-3  mt-2 bg-[#FFA500]'></div> <div className='text-[14px] '>40 - 50  </div></div>
                                            <div className='flex'>  <div className='border-2 w-8 h-6 mr-3 mx-3  mt-2 mb-3 bg-[#FFC000]'></div> <div className='text-[14px] '>30 - 40  </div></div>
                                            <div className='flex'>  <div className='border-2 w-8 h-6 mr-3 mx-3 mt-2 bg-[#FFD700]'></div> <div className='text-[14px] '>20 - 30  </div></div>
                                            <div className='flex'>  <div className='border-2 w-8 h-6 mr-3 mx-3  mt-2 bg-[#FFEA00]'></div> <div className='text-[14px] '>10 - 20  </div></div>
                                            <div className='flex'>  <div className='border-2 w-8 h-6 mr-3 mx-3  mt-2 mb-3 bg-[#fdfd96]'></div> <div className='text-[14px] '>0 - 10  </div></div>

                                        </div> :

                                        value1 === 'Root-zone' ?
                                            <div className='py-6 mx-7'>
                                                <div className='my-5'>MS: Root-zone Soil Moisture (%)</div>

                                                <div className='flex'>  <div className='border-2 w-8 h-6 mr-3 mx-3 mt-2 bg-[#00008B]'></div> <div className='text-[14px] '>50 - 60  </div></div>
                                                <div className='flex'>  <div className='border-2 w-8 h-6 mr-3 mx-3  mt-2 bg-[#4682B4]'></div> <div className='text-[14px] '>40 - 50  </div></div>
                                                <div className='flex'>  <div className='border-2 w-8 h-6 mr-3 mx-3  mt-2 mb-3 bg-[#228B22]'></div> <div className='text-[14px] '>30 - 40  </div></div>
                                                <div className='flex'>  <div className='border-2 w-8 h-6 mr-3 mx-3 mt-2 bg-[#9ACD32]'></div> <div className='text-[14px] '>20 - 30  </div></div>
                                                <div className='flex'>  <div className='border-2 w-8 h-6 mr-3 mx-3  mt-2 bg-[#FFD700]'></div> <div className='text-[14px] '>10 - 20  </div></div>
                                                <div className='flex'>  <div className='border-2 w-8 h-6 mr-3 mx-3  mt-2 mb-3 bg-[#FFA500]'></div> <div className='text-[14px] '>0 - 10  </div></div>

                                            </div> : <div className='py-6 mx-7'> No legend available </div>
                                }
                            </div>
                            <div className='my-7 ml-72'>
                                <div className='mb-2'>Download</div>

                                <DownloadFile fileName={value1} date={date} path={'nowcast'} name={'Download Forecast TIF File'} />
                            </div>

                        </div>


                    </div>
                    <div className='left mx-5 mt-4'>
                        <div>
                            <div className='bordder-4 h-20 flex justify-center items-center space-x-4'>
                                <div className=' py-5 text-lg '>
                                    <p className='mx-5 font-bold'>SELECT INDICES </p>
                                    <select className='border-solid border-2 text-xs border-orange-300 rounded-full hover:border-blue-300 w-56 h-10' value={value2} onChange={handleChange2}>
                                        <option value="CDI">MS: CDI- Combined Drought Index</option>
                                        <option value="MSDrought">MS: Drought Severity</option>
                                        <option value="MSDry">MS: Dry Spell Events</option>
                                        <option value="SMDI">MS: SMDI- Soil Moisture Decifit Index</option>
                                        <option value="SPI1">MS: SPI 1 month - Standardized Precipitation Index (1 month)</option>
                                        <option value="SPI3">MS: SPI 3 month - Standardized Precipitation Index (3 month)</option>
                                        <option value="SPI6">MS: SPI 6 month - Standardized Precipitation Index (6 month)</option>
                                        <option value="SRI1">MS: SRI 1 month - Standardized Runoff Index (1 month)</option>
                                        <option value="SRI3">MS: SRI 3 month - Standardized Runoff Index (3 month)</option>
                                        <option value="SRI6">MS: SRI 6 month - Standardized Runoff Index (6 month)</option>
                                        <option value="MSR">MS: Rainfall (mm)</option>
                                        <option value="SSM">MS: Surface Soil Moisture (mm)</option>
                                        <option value="RSM">MS: Root-zone Soil Moisture (mm)</option>
                                        <option value="ST">MS: Surface Temperature (°C)</option>
                                        <option value="MSST">MS: Soil Temperature (°C)</option>
                                        <option value="MAT">MS: Minimum Air Temperature (°C)</option>
                                        <option value="MSMAT">MS: Maximum Air Temperature (°C)</option>
                                        <option value="RH">MS: Relative Humidity (%)</option>
                                        <option value="MSE">MS: Evaporation (mm)</option>
                                        <option value="NSF">MS: Net Shortwave Flux (W/m2)</option>
                                        <option value="NLF">MS: Net Longwave Flux (W/m2)</option>
                                        <option value="PAR">MS: PAR - Photosynthetically Active Radiation (W/m2)</option>
                                        <option value="SR">MS: Surface Runoff (mm)</option>
                                        <option value="BF">MS: Base flow (mm/day)</option>
                                    </select>
                                </div>
                                <div className=' py-5 text-lg '>
                                    <p className='mx-5 font-bold'>SELECT PERIODICITY </p>
                                    <select className='border-solid border-2 text-xs border-orange-300 rounded-full hover:border-blue-300 w-56 h-10' value={value3} onChange={handleChange3}>
                                        <option value="1 Month">1 Month</option>
                                        <option value="3 Months">3 Months</option>
                                        <option value="1 Year">1 Year</option>
                                    </select>

                                </div>
                            </div>
                            <p className='text-xs'>An area chart compares Min and Max values of nowcast and forecast data of MS: <span className='font-bold'>{value2} </span>  in Senegal region | <span className='font-bold'>Periodicity: {value3}</span></p>
                            {/* <h1> GRAPH </h1> */}
                            <div className='my-2 mb-64'>
                                <div className=''>
                                    <img className='opacity-25' src={graph1} />
                                </div>
                                <div className='  px-[2rem] text-red-600 text-4xl font-bold -mt-64 bg-slate-50 bg-opacity-[0.4]'> <span className=''> Graph work in progress </span></div>

                            </div>
                        </div>
                        <div className='my-10'>
                            <div className='bordder-4 h-20 mb-3 space-x-4'>
                                <div className=' py-5 text-lg '>
                                    <p className='mx-5 font-bold'>SELECT INDICES </p>
                                    <select className='border-solid border-2 text-xs border-orange-300 rounded-full hover:border-blue-300 w-56 h-10' value={value4} onChange={handleChange4}>
                                        <option value="CDI">MS: CDI- Combined Drought Index</option>
                                        <option value="MSDrought">MS: Drought Severity</option>
                                        <option value="MSDry">MS: Dry Spell Events</option>
                                        <option value="SMDI">MS: SMDI- Soil Moisture Decifit Index</option>
                                        <option value="SPI1">MS: SPI 1 month - Standardized Precipitation Index (1 month)</option>
                                        <option value="SPI3">MS: SPI 3 month - Standardized Precipitation Index (3 month)</option>
                                        <option value="SPI6">MS: SPI 6 month - Standardized Precipitation Index (6 month)</option>
                                        <option value="SRI1">MS: SRI 1 month - Standardized Runoff Index (1 month)</option>
                                        <option value="SRI3">MS: SRI 3 month - Standardized Runoff Index (3 month)</option>
                                        <option value="SRI6">MS: SRI 6 month - Standardized Runoff Index (6 month)</option>
                                        <option value="MSR">MS: Rainfall (mm)</option>
                                        <option value="SSM">MS: Surface Soil Moisture (mm)</option>
                                        <option value="RSM">MS: Root-zone Soil Moisture (mm)</option>
                                        <option value="ST">MS: Surface Temperature (°C)</option>
                                        <option value="MSST">MS: Soil Temperature (°C)</option>
                                        <option value="MAT">MS: Minimum Air Temperature (°C)</option>
                                        <option value="MSMAT">MS: Maximum Air Temperature (°C)</option>
                                        <option value="RH">MS: Relative Humidity (%)</option>
                                        <option value="MSE">MS: Evaporation (mm)</option>
                                        <option value="NSF">MS: Net Shortwave Flux (W/m2)</option>
                                        <option value="NLF">MS: Net Longwave Flux (W/m2)</option>
                                        <option value="PAR">MS: PAR - Photosynthetically Active Radiation (W/m2)</option>
                                        <option value="SR">MS: Surface Runoff (mm)</option>
                                        <option value="BF">MS: Base flow (mm/day)</option>
                                    </select>
                                </div>
                            </div>
                            <p className='text-xs'>An area chart compares Min and Max values of nowcast and forecast data of MS: <span className='font-bold'>{value4} </span>  in Senegal region | <span className='font-bold'>Periodicity: {value3}</span></p>
                            {/* <h1> GRAPH </h1> */}
                            <div className='my-2 mb-64'>
                                <div className=''>
                                    <img className='opacity-25' src={graph2} />
                                </div>
                                <div className='  px-[2rem] text-red-600 text-4xl font-bold -mt-64 bg-slate-50 bg-opacity-[0.4]'> <span className=''> Graph work in progress </span></div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default IntractiveMap